import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  UserName: string;
  Password: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }


  LoginClick(){
    debugger;
      this.isShownError = true;
      this.isShownSuccess = true;
      this.ErrorMsg = "";
      this.SuccessMsg = "";
  
      var vUserName = this.UserName;
      var vPassword = this.Password;
      if (vUserName == undefined || vUserName == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter The UserName.";
        return false;
      }
      if (vPassword == undefined || vPassword == "") {
        this.isShownError = false;
        this.ErrorMsg = "Please Enter The Password.";
        return false;
      }
      //window.location.href = '/readPNR';

      var value = this.http.get(environment.apiUrl + 'Login/GetLoginDetails?sUserName=' + vUserName + '&sPassword=' + vPassword).toPromise().then(
        (data: any) => {
          debugger;
          if (data.length != 0) {
            var vData = data;
            var vUserId = vData["0"].userDetaisId;
            var vUserName = vData["0"].userName;
            var vEmailID = vData["0"].emailId;
            var vUserType=vData["0"].userType;
            localStorage.clear();
            localStorage.setItem("LoginMail",vEmailID);
            localStorage.setItem("LoginId",vUserId);
            localStorage.setItem("UserType",vUserType);
            var vScreens=vData["0"].screens;
            var vRoleName=vData["0"].roleName;
            var vEmployeeId=vData["0"].employeeId;
            localStorage.setItem("RoleName",vRoleName);
            localStorage.setItem("EmployeeId",vEmployeeId);
            //if(vRoleName)

            var vUR = vScreens.split("|");
          for (var i = 0; i < vUR.length; i++) {
            var val = vUR[i];
            switch (val) {
              case "AduitUploadRead": {
                localStorage.setItem('AduitUploadRead', "True");
                break;
              }
              case "AduitUploadWrite": {
                localStorage.setItem('AduitUploadWrite', "True");
                break;
              }
              case "AuditOutputRead": {
                localStorage.setItem('AuditOutputRead', "True");
                break;
              }
              case "AuditOutputWrite": {
                localStorage.setItem('AuditOutputWrite', "True");
                break;
              }
              case "ChaRead": {
                localStorage.setItem('ChaRead', "True");
                break;
              }
              case "ChaWrite": {
                localStorage.setItem('ChaWrite', "True");
                break;
              }
              case "CountryRead": {
                localStorage.setItem('CountryRead', "True");
                break;
              }
              case "CountryWrite": {
                localStorage.setItem('CountryWrite', "True");
                break;
              }
      
              case "CurrencyRead": {
                localStorage.setItem('CurrencyRead', "True");
                break;
              }
              case "CurrencyWrite": {
                localStorage.setItem('CurrencyWrite', "True");
                break;
              }
      
              case "ExchangeRead": {
                localStorage.setItem('ExchangeRead', "True");
                break;
              }
      
              case "ExchangeWrite": {
                localStorage.setItem('ExchangeWrite', "True");
                break;
              }
              case "PortRead": {
                localStorage.setItem('PortRead', "True");
                break;
              }
              case "PortWrite": {
                localStorage.setItem('PortWrite', "True");
                break;
              }
              case "CustomRead": {
                localStorage.setItem('CustomRead', "True");
                break;
              }
              case "CustomWrite": {
                localStorage.setItem('CustomWrite', "True");
                break;
              }
              case "EximRead": {
                localStorage.setItem('EximRead', "True");
                break;
              }
              case "EximWrite": {
                localStorage.setItem('EximWrite', "True");
                break;
              }
              case "AntiDumbingRead": {
                localStorage.setItem('AntiDumbingRead', "True");
                break;
              }
              case "AntiDumbingWrite": {
                localStorage.setItem('AntiDumbingWrite', "True");
                break;
              }
              case "ClientRead": {
                localStorage.setItem('ClientRead', "True");
                break;
              }
              case "ClientWrite": {
                localStorage.setItem('ClientWrite', "True");
                break;
              }
              case "OnboardingRead": {
                localStorage.setItem('OnboardingRead', "True");
                break;
              }
              case "OnboardingWrite": {
                localStorage.setItem('OnboardingWrite', "True");
                break;
              }
              case "ContractsRead": {
                localStorage.setItem('ContractsRead', "True");
                break;
              }
              case "ContractsWrite": {
                localStorage.setItem('ContractsWrite', "True");
                break;
              }
              case "NdaRead": {
                localStorage.setItem('NdaRead', "True");
                break;
              }
              case "NdaWrite": {
                localStorage.setItem('NdaWrite', "True");
                break;
              }
              case "EmployeeRead": {
                localStorage.setItem('EmployeeRead', "True");
                break;
              }
              case "EmployeeWrite": {
                localStorage.setItem('EmployeeWrite', "True");
                break;
              }
      
              case "AssignEmpRead": {
                localStorage.setItem('AssignEmpRead', "True");
                break;
              }
              case "AssignEmpWrite": {
                localStorage.setItem('AssignEmpWrite', "True");
                break;
              }
              case "PartsRead": {
                localStorage.setItem('PartsRead', "True");
                break;
              }
              case "PartsWrite": {
                localStorage.setItem('PartsWrite', "True");
                break;
              }
              case "LicenseRead": {
                localStorage.setItem('LicenseRead', "True");
                break;
              }
              case "LicenseWrite": {
                localStorage.setItem('LicenseWrite', "True");
                break;
              }
              case "BondRead": {
                localStorage.setItem('BondRead', "True");
                break;
              }
              case "BondWrite": {
                localStorage.setItem('BondWrite', "True");
                break;
              }
              case "BankRead": {
                localStorage.setItem('BankRead', "True");
                break;
              }
              case "BankWrite": {
                localStorage.setItem('BankWrite', "True");
                break;
              }
              case "ImportPartRead": {
                localStorage.setItem('ImportPartRead', "True");
                break;
              }
              case "ImportPartWrite": {
                localStorage.setItem('ImportPartWrite', "True");
                break;
              }
              case "UserRightsRead": {
                localStorage.setItem('UserRightsRead', "True");
                break;
              }
              case "UserRightsWrite": {
                localStorage.setItem('UserRightsWrite', "True");
                break;
              }
            }
          }

            window.location.href = '/Dashboard';
          }
          else
          {
            this.isShownError = false;
        this.ErrorMsg = "Login Failed, Incorrect UserrId OR Password";
        
        
        return false;
          }
        });
  }

  viewPassword(){
    debugger;
  if ((document.getElementById('password') as HTMLInputElement).type == 'password')
  {
    (document.getElementById('password') as HTMLInputElement).type='text';
    (document.getElementById('pass-status') as HTMLInputElement).className='fa fa-eye-slash';
  }
  else
  {
    (document.getElementById('password') as HTMLInputElement).type='password';
    (document.getElementById('pass-status') as HTMLInputElement).className='fa fa-eye';
  }

  }
}
